
import { Table } from 'react-bootstrap';

import { renderTableHeader } from 'components/PaginationContainer';
import Checkbox from 'components/Checkbox';

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSortableTable } from 'hooks/useSortableTable';
import useStickyHeader from 'hooks/useStickyHeader';

import { defaultColumns } from "../../useConst";

import { size, isNil, cloneDeep } from "lodash";

const columns = defaultColumns();

const LicensesTableMSP = ({
  info,
  dataList,
  pagination,
  search,
  setDataList
}) => {
  const { t } = useTranslation();

  const { tableRef, stickyStyle } = useStickyHeader();
  const [tableData, handleSorting] = useSortableTable(dataList, columns);
  const [sortField, setSortField] = useState('');
  const [order, setOrder] = useState('asc');
  const [currentTableData, setCurrentTableData] = useState([]);

  useEffect(() => {
    setCurrentTableData(tableData);
  }, [dataList]);

  useEffect(() => {
    setCurrentTableData(tableData);
  }, [search, tableData]);

  const isCheckedAll = () => {
    if (isNil(currentTableData) || size(currentTableData) === 0)
      return false;
    for (const item of currentTableData) {
      if (!item.isChecked)
        return false;
    }
    return true;
  };

  const checkedAll = () => {
    const isAll = isCheckedAll();
    const copy = cloneDeep(currentTableData);
    for (let item of copy)
      item.isChecked = !isAll;
    setDataList(copy);
  };

  const checkItem = (index) => {
    const copy = cloneDeep(currentTableData);
    const target = copy[index];
    target.isChecked = isNil(target.isChecked) ? true : !target.isChecked;
    setDataList(copy);
  };

  return (
    <Table responsive striped hover className="table-container" ref={tableRef}>
      <thead style={stickyStyle}>
        <tr>
          <th>
            <Checkbox
              id="s_l_msp_isCheckAll"
              disabled={info.actions?.editInvalid}
              onChange={e => {
                checkedAll();
              }}
              checked={isCheckedAll()}
            />
          </th>
          <th>#</th>
          {renderTableHeader(columns, order, setOrder, sortField, setSortField, handleSorting)}
        </tr>
      </thead>
      <tbody>
        {currentTableData?.length > 0 ?
          (currentTableData.map((item, index) => {
            return (
              <tr key={index}>
                <td>
                  <Checkbox
                    id={`s_l_msp_isCheck_${index}`}
                    disabled={item.disabled}
                    onChange={e => {
                      checkItem(index);
                    }}
                    checked={item.isChecked}
                  />
                </td>
                <td>{(pagination.current - 1) * pagination.pageLimit + index + 1}</td>
                <td>{item.licenseTypeLabelFull}</td>
                <td>{item.licenseStateLabelFull}</td>
                <td>{item.licenseKey}</td>
                <td>{item.termUnitLabelFull}</td>
                <td>{item.deviceTypeLabelFull}</td>
                <td>{item.releasedAtFormat}</td>
                <td>{item.preOrganizationName}</td>
                <td>{item.organizationName}</td>
                <td>{item.orgUid}</td>
                <td>{item.orgTypeLabel}</td>
                <td>{item.deviceUid}</td>
                <td>{item.deviceModelName}</td>
                <td>{item.macAddress}</td>
                <td>{item.startDateFormat}</td>
                <td>{item.endDateFormat}</td>
                <td>{item.remainDayUnitLabelFull}</td>
              </tr>
            );
          }))
          : (<tr>
            <td colSpan="16" style={{ textAlign: 'center', height: 35 }}>
              {t('ad01242a61')}
            </td>
          </tr>
          )
        }
      </tbody>
    </Table>
  );
};

export default LicensesTableMSP;